import { useCallback, useState } from "react";
import { TRANSITION_DURATION } from "../constants";

export const useTransitionDuration = () => {
  const [transitionDuration, setTransitionDuration] = useState(0);

  const applyTransition = useCallback(() => {
    setTransitionDuration(TRANSITION_DURATION);
  }, []);

  const disableTransition = useCallback(() => {
    setTransitionDuration(0);
  }, []);

  return {
    applyTransition,
    disableTransition,
    transitionDuration,
  };
};
